<!-- PASSWD INPUT -->
<div class="validable-input-margins" [formGroup]="formGroup">
  <div class="input-group">
    <div class="input-group-prepend form-icon col-1 justify-content-center align-items-center">
      <i class="material-icons notranslate">{{ icon }}</i>
    </div>
    <mat-form-field
      appearance="outline"
      [ngClass]="{ 'has-primary': this.isValid === true }"
      [ngClass]="displayErrors(customId)"
      class="col"
    >
      <mat-label>{{ text | translate }}</mat-label>
      <input
        #internalInput
        matInput
        [type]="passwordVisible ? 'text' : 'password'"
        name="{{ customId }}"
        placeholder="{{ text | translate }}"
        (ngModelChange)="validation($event)"
        formControlName="{{ customId }}"
      />

      <app-field-error-display
        [displayError]="isFieldNotValid(customId)"
        [errorMsg]="getErrorText() | translate"
      >
      </app-field-error-display>

      <button
        type="button"
        mat-icon-button
        matSuffix
        [attr.aria-label]="(passwordVisible ? 'INPUTS.HIDE_PASSWORD' : 'INPUTS.SHOW_PASSWORD') | translate"
        [attr.aria-pressed]="passwordVisible"
        (click)="passwordVisible = !passwordVisible"
      >
        <mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>
